export default {
  header: 'Wir konnten deine Bestellung nicht laden',
  text: 'Beim Vorbereiten deiner Bestellung ist etwas schiefgelaufen. Dein Warenkorb ist gespeichert — bitte versuche es erneut.',
  retry: 'Erneut versuchen',
  address_header: 'Wir brauchen deine Lieferadresse',
  address_text:
    'Wir können deinen Gesamtbetrag erst berechnen, wenn wir wissen, wohin wir liefern. Dein Warenkorb ist gespeichert.',
  address_action: 'Lieferadresse hinzufügen',
  back_checkout: 'Zurück zu deiner Bestellung',
  back_basket: 'Zurück zum Warenkorb',
};
